module.exports = __webpack_public_path__ + "static/media/mitid.1cfeed37.svg";